import React from 'react';
import { Link } from 'react-router-dom';
import { getCategoryCover, getCategoryLink } from '../../utils/category-utils';
import { getItemCover } from '../../utils/item-utils';
import { renderRibbonIfNecessary } from '../../utils/products';
import { LoadingIndicator } from '../../components/loading-indicator';
import './index.less';
import { ISubscriptionState } from '../../reducers/subscription-reducers';
import { ICategory } from '../../reducers/category-reducers';
import { IItem } from '../../reducers/item-reducers';

interface ICompactItemListProps {
	items: IItem[];
	categories?: ICategory[];
	imageHeight: number;
	canShowMore?: boolean;
	onShowMore?: () => void;
	showMoreLoading?: boolean;
	subscription: ISubscriptionState;
}

export class CompactItemList extends React.Component<ICompactItemListProps> {
	onShowMore = () => {
		const { onShowMore } = this.props;
		if (onShowMore) {
			onShowMore();
		}
	};

	_renderItem(item: IItem) {
		const { imageHeight } = this.props;
		const cover = getItemCover({
			item,
			height: imageHeight,
			maxWidth: 3 * imageHeight,
		});
		const coverEl = cover && (
			<img src={cover.url} style={{ height: cover.height, width: cover.width }} alt={item.title} />
		);

		return (
			<div className={'block-with-text-truncate'} style={{ width: cover && cover.width }}>
				<Link to={'/items/' + item.id} title={item.title} style={{ color: 'white' }}>
					{coverEl}
					<span>{item.title}</span>
				</Link>
			</div>
		);
	}

	_renderCategory(category: ICategory) {
		const { imageHeight } = this.props;
		const cover = getCategoryCover({
			category,
			height: imageHeight,
			maxWidth: 3 * imageHeight,
		});
		const coverEl = cover && (
			<img src={cover.url} style={{ height: cover.height, width: cover.width }} alt={category.title} />
		);

		return (
			<div className={'block-with-text-truncate'} style={{ width: cover && cover.width }}>
				<Link to={getCategoryLink(category)} title={category.title} style={{ color: 'white' }}>
					{coverEl}
					<span>{category.title}</span>
				</Link>
			</div>
		);
	}

	render() {
		const { items, categories, canShowMore, showMoreLoading } = this.props;

		return (
			<div className="compact-item-list">
				<ul>
					{categories
						? categories.map((category, catIndex) => (
								<li key={`${category.id}-${catIndex}`}>{this._renderCategory(category)}</li>
						  ))
						: null}
				</ul>
				<ul>
					{items.map((item, itemIndex) => {
						const { id, licenseKind } = item;

						return (
							<li key={`${id}-${itemIndex}`}>
								{this._renderItem(item)}
								{renderRibbonIfNecessary(
									{
										showFreeCornerRibbon: licenseKind === 'free',
										showPromotionRibbon: licenseKind === 'plus',
										showOwnedCornerRibbon: licenseKind === 'owned',
									},
									'compact'
								)}
							</li>
						);
					})}
				</ul>
				{canShowMore ? (
					showMoreLoading ? (
						<LoadingIndicator />
					) : (
						<button onClick={this.onShowMore}>more »</button>
					)
				) : (
					false
				)}
			</div>
		);
	}
}
